import {combineReducers} from 'redux';
import userReducer from './userReducer';
import categoriesReducer from './categoriesReducer';
import statesReducer from './statesReducer';

export default combineReducers({
  user: userReducer,
  categories: categoriesReducer,
  states: statesReducer
});